"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutFormSchema = void 0;
const Yup = __importStar(require("yup"));
require("yup-phone");
exports.CheckoutFormSchema = Yup.object()
    .shape({
    firstName: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('First name is required'),
    lastName: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('Last name is required'),
    fullNameOrCompanyName: Yup.string().nullable().max(60, 'Too Long!'),
    addressLine1: Yup.string().min(1, 'Too Short!').max(60, 'Too Long!').required('Address is required'),
    addressLine2: Yup.string().nullable().max(60, 'Too Long!'),
    houseUnit: Yup.string().nullable(),
    city: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('City is required'),
    postalCode: Yup.string()
        .required('Postal code is required')
        .matches(/^[0-9]+$/, 'Must be only digits')
        .min(5, 'Must be exactly 5 digits')
        .max(5, 'Must be exactly 5 digits'),
    state: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('State is required'),
    country: Yup.string().min(1, 'Too Short!').max(50, 'Too Long').required('Country is required'),
    phoneNumber: Yup.string()
        .matches(/^(\+?601)[0-46-9]-*[0-9]{7,8}$/, 'Must be a valid phone number and with country code +6')
        .required('Phone number is required'),
    emailAddress: Yup.string().email('Must be a valid email').required('Email is required'),
    shipToDifferentAddress: Yup.boolean(),
    notes: Yup.string().nullable().max(250, 'Too Long!'),
    paymentMethod: Yup.string().max(20).required('Payment Method is required'),
    paymentBankCode: Yup.string().min(5).required('Payment Prefered Bank is required'),
    shippingAddressLine1: Yup.string()
        .nullable()
        .when('shipToDifferentAddress', {
        is: true,
        then: Yup.string().min(1, 'Too Short!').max(60, 'Too Long!').required('Shipping address is required'),
    }),
    shippingAddressLine2: Yup.string().nullable().max(60, 'Too Long!'),
    shippingHouseUnit: Yup.string().nullable(),
    shippingCity: Yup.string()
        .nullable()
        .when('shipToDifferentAddress', {
        is: true,
        then: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('Shipping city is required'),
    }),
    shippingPostalCode: Yup.string()
        .nullable()
        .when('shipToDifferentAddress', {
        is: true,
        then: Yup.string()
            .required('Shipping postal code is required')
            .matches(/^[0-9]+$/, 'Must be only digits')
            .min(5, 'Must be exactly 5 digits')
            .max(5, 'Must be exactly 5 digits'),
    }),
    shippingState: Yup.string()
        .nullable()
        .when('shipToDifferentAddress', {
        is: true,
        then: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('Shipping state is required'),
    }),
    shippingCountry: Yup.string()
        .nullable()
        .when('shipToDifferentAddress', {
        is: true,
        then: Yup.string().min(1, 'Too Short!').max(50, 'Too Long!').required('Shipping country is required'),
    }),
})
    .required();
//# sourceMappingURL=FLDStore.js.map